<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
  <g fill="#4562FF" fill-rule="nonzero">
    <path
      d="M3.03.018h12.584A2.389 2.389 0 0 1 18 2.404v7.701a2.389 2.389 0 0 1-2.378 2.386v3.495L10.6 12.49H3.03a2.389 2.389 0 0 1-2.386-2.386v-7.7A2.389 2.389 0 0 1 3.03.017zM1.661 10.105c0 .755.614 1.37 1.37 1.37h7.888l3.686 2.564v-2.565h1.009a1.37 1.37 0 0 0 1.37-1.369v-7.7a1.37 1.37 0 0 0-1.37-1.37H3.03a1.37 1.37 0 0 0-1.369 1.37v7.7z"/>
    <path stroke="#FFF" stroke-width=".2"
          d="M13.355 3.611H5.289v1.017h8.066zM13.355 5.78H5.289v1.018h8.066zM13.355 7.95H5.289v1.017h8.066z"/>
  </g>
</svg>
